import {createSelector} from 'reselect';
import {getNewAddress, getSettings} from '../selectors';

export default createSelector(
  [getSettings, getNewAddress],
  (settings, address) => !!(settings.delivery_countries_requiring_state
    && settings.delivery_countries_requiring_state.includes(address?.country)),
);
